import utils from './utils.js';
import analytics from '@/utils/analytics.js';

const _ = require('lodash');

const funcs = {
    getAttachmentsForLP(handle, lpId) {
        const allAttachmentsById = _.keyBy(handle.$store.state.attachments, '_id');

        if (!handle.$store.state.learningPaths && !handle.$store.state.learningPaths.items) {
            return [];
        }

        const lp = _.find(handle.$store.state.learningPaths.items, function(learningPath) {
            return learningPath.lpId === lpId;
        });

        if(!lp || !lp.items) return [];

        const lpItemsWithAttachments = _.filter(lp.items, lpItem => {
            return lpItem.attachment;
        });

        return lpItemsWithAttachments.map(lpItem => allAttachmentsById[lpItem.attachment]);
    },
    getLPData: function (handle, lpId) {
        var lpData = {};

        var data = _.find(handle.$store.state.learningPaths.items, function(learningPath) {
            return learningPath.lpId === lpId;
        });

        if (!data || !data.items) return lpData;
        lpData.lpItems = data.items;

        var tagIds = new Set();
        
        var allAttachments = handle.$store.state.attachments;
        var allResources = handle.$store.state.resources;
        var allTags = handle.$store.state.learningPaths.tags;
        var allUserStates = handle.$store.state.learningPaths.userState;

        var attachments = []
        var resources = []
        var tags = []
        var userStates = []

        _.each(lpData.lpItems, function(lpItem) {
            // get all tags
            _.each(lpItem.tags, function(tagId) {
                tagIds.add(tagId);
            });

            if(lpItem.attachment) {
                var attachment = _.find(allAttachments, function(att) { return att._id === lpItem.attachment})
                if(attachment) {
                    attachments.push(attachment);

                    var resource = _.find(allResources, function(res) { return res._id === attachment.resource})
                    if(resource) {
                        resources.push(resource);
                    }
                }
            }

            var userState = _.find(allUserStates, function(state) { return state._id === lpItem._id})
            if(userState) {
                userStates.push(userState);
            }
        });

        _.each(Array.from(tagIds), function(tagId) {
            var tag = _.find(allTags, function(tag) { return tag.tag_id === tagId});
            if(tag) {
                tags.push(tag)
            }
        });

        lpData.tags = _.keyBy(tags, "tag_id");
        lpData.userState = userStates;
        lpData.resources = resources;
        lpData.attachments = attachments;

        // force mark as downloaded
        _.each(lpData.resources, function(resource) {
            resource.downloaded = true;
            resource.thumbnail = utils.resourceTypeImgNoPath(resource.category, resource.url);
        });

        return lpData;
    },
    getBookById: function(handle, bookId) {
        return _.find(handle.$store.state.bookList, function(book) {
            return book.id === bookId || book._id === bookId;
        });
    },
    getBooks: function(handle, groupCode) {
        var books = [];
        if(groupCode) {
            books = _.filter(handle.$store.state.bookList, function(book) {
                return book.groups && book.groups.indexOf(groupCode) >= 0;
            });
        } else {
            books = handle.$store.state.bookList;
        }

        var sortedBooks = _.orderBy(books, [ function(book) { return book.title.trim().toLowerCase(); } ], ['asc']);
        return sortedBooks;
    },
    getPagesOpened: function(handle, groupCode) {
        const booksInGroup = _.map(funcs.getBooks(handle, groupCode), function(book) { return book.id});
        return _.filter(handle.$store.state.pagesOpened, function(pagesOpenedPerBook) {
            return booksInGroup.indexOf(pagesOpenedPerBook.book) >= 0;
        })
    },
    addPageOpened: function(handle, bookId, pageIndex, timeOnPage) {
        // if the book has never been added, add it
        if(!handle.$store.state.pagesOpened[bookId]) {
            handle.$store.state.pagesOpened[bookId] = {
                book: bookId,
                pages: {}
            };
        }

        // if the pages has never been added or the new timeonpage is larger, add it
        if(!handle.$store.state.pagesOpened[bookId].pages[pageIndex] || handle.$store.state.pagesOpened[bookId].pages[pageIndex].timeOnPage < timeOnPage) {
            handle.$store.state.pagesOpened[bookId].pages[pageIndex] = {
                pageIndex: pageIndex,
                timeOnPage: timeOnPage
            };
        }
    },
    addAttachment: function(handle, attachment) {
        handle.$store.state.attachments.push(attachment);
    },
    addResource: function(handle, resource) {
        handle.$store.state.resources.push(resource);
    },
    updateResource: function(handle, resource) {
        handle.$store.state.resources[handle.$store.state.resources.indexOf(_.find(handle.$store.state.resources, function(res) {
            return res._id === resource._id;
        }))] = resource;
    },
    removeResource: function(handle, resource) {
        
        handle.$store.state.resources.splice(handle.$store.state.resources.indexOf(_.find(handle.$store.state.resources, function(res) {
            return res._id === resource._id;
        })),1)
    },
    removeResourceAndItsAttachments: function(handle, resource) {
        // remove resource
        funcs.removeResource(handle, resource)

        var atts = funcs.getAttachmentsByResourceId(handle, resource._id);
        _.each(atts, function(att) {
            funcs.removeAttachmentById(handle, att._id);
        });
    },
    getResourceById: function(handle, resourceId) {        
        return _.find(handle.$store.state.resources, function(resource) {
            return resource._id === resourceId;
        });
    },
    getAttachmentById: function(handle, attachmentId) {        
        return _.find(handle.$store.state.attachments, function(attachment) {
            return attachment._id === attachmentId;
        });
    },
    getAttachmentsByResourceId: function(handle, resourceId) {
        return _.filter(handle.$store.state.attachments, function(attachment) {
            return attachment.resource === resourceId;
        });
    },
    removeAttachmentById: function(handle, attachmentId) {
        handle.$store.state.attachments.splice(handle.$store.state.attachments.indexOf(_.find(handle.$store.state.attachments, function(att) {
            return att._id === attachmentId;
        })),1)
    },
    getFlashcardHistory: function(handle, resourceId) {
        return _.find(handle.$store.state.flashCardHistory, function(flashCardHistory) {
            return flashCardHistory.resource === resourceId;
        });
    },
    getFlashcardDeckTitle: function(handle, flashcarddeckId) {
        var a = _.find(handle.$store.state.resources, function(res) {
            return res._id === flashcarddeckId;
        });
        return a.title;
    },
    isSpecificAssessment: function(attachment) {
        return attachment.settings && attachment.settings.title && attachment.settings.title.length > 0;
    },
    isUnread: function(resource, attachments) {
        if(resource.private) return false;
        
        if(resource.category === 'assessment') {
            _.each(attachments, function(attachment) {
                if(funcs.isSpecificAssessment(attachment)) {
                    return !attachment.isRead;
                }
            });
        }

        return !resource.isRead;
    },
    markAsRead: function(handle, resource, attachment) {
        if(resource.category === 'assessment' && attachment) { 
            if(funcs.isSpecificAssessment(attachment)) {
                if(!attachment.isRead) {
                    attachment.isRead = attachment.isReadDirty = true;
                }
            } else {
                if(!resource.isRead) {
                    resource.isRead = resource.isReadDirty = true;
                }
            }
        } else {
            if(!resource.isRead) {
                resource.isRead = resource.isReadDirty = true;
            }
        }

        // if resource is part of LP then send LearningPathProgressChanged stat
        if(attachment) {
            _.each(handle.$store.state.learningPaths.items, LP => {
                _.each(LP.items, item => {
                    if (item.attachment === attachment._id) {
                        item.progress = 100.00;
                        item.isRead = true;
                        // learningPathProgressChanged: function(handle, learningPathId, learningPathItemId, attachmentId, progress)
                        if (funcs.getAnalytics(handle)) {
                            analytics.learningPathProgressChanged(handle, LP.lpId, item._id, attachment._id, item.progress);
                        }
                    }
                })
            })
        }
    },
    getDrawings(attachments, resources) {
        const drawingResources = _.filter(resources, res => {
            return res.category === "drawing";
        });

        const drawingResourcesById = _.keyBy(drawingResources, "id");

        const drawingAttachments = _.filter(attachments, att => {
            return drawingResourcesById[att.resource];
        });

        return {attachments: drawingAttachments, resourcesById: drawingResourcesById};
    },
    getAttachmentsAndResourcesForBook: function(handle, bookId) {
        var attachmentsAndResources = {
            "attachments": [],
            "resources": {}
        };
        attachmentsAndResources.attachments = _.filter(handle.$store.state.attachments, function(att) {
            return att.book === bookId;
        });
        var resourcesForAttachments = _.map(attachmentsAndResources.attachments, function(att) {
            return att.resource;
        });
        attachmentsAndResources.resources = _.filter(handle.$store.state.resources, function(res) {
            return resourcesForAttachments.indexOf(res._id) >= 0;
        });
        return attachmentsAndResources;
    },
    getAttachmentsPerBook: function(handle) {
        return _.groupBy(_.filter(handle.$store.state.attachments, att => att.book), "book");
    },
    getResourcesPerBookNoAnnotations: function(handle) {
        const attachmentsPerBook = funcs.getAttachmentsPerBook(handle);
        const resourcesById = _.keyBy(handle.$store.state.resources, "_id");

        var booksById = {};

        _.each(Object.keys(attachmentsPerBook), function(book) {
            if(!booksById[book]) {
                booksById[book] = [];
            }

            // filter out annotations
            attachmentsPerBook[book] = _.filter(attachmentsPerBook[book], att => resourcesById[att.resource] && resourcesById[att.resource].category && !utils.isAnnotation(resourcesById[att.resource]))
                
            var attachmentsPerResource = _.groupBy(attachmentsPerBook[book], "resource");

            _.each(attachmentsPerResource, function(attachments, resourceId) {
                const set = funcs.getInstancesForResourceAttachmentSet(attachments, resourcesById[resourceId]);
                booksById[book] = booksById[book].concat(set);
            });
        });

        return booksById;
    },
    getInstancesForResourceAttachmentSet(attachmentsForResource, resource) {
        if(!resource || attachmentsForResource.length === 0) {
            return [];
        }

        const specificAssessmentInstancesSplit = _.partition(attachmentsForResource, function(attachment) {
            return resource && resource.category === 'assessment' && funcs.isSpecificAssessment(attachment);
        });

        const specificAssessmentInstances = specificAssessmentInstancesSplit[0];
        const otherAttachments = specificAssessmentInstancesSplit[1];

        var unreadInstances = [];
        
        // add each specific instance as an item
        _.each(specificAssessmentInstances, function(attachment) {
            unreadInstances.push({
                attachments: [attachment],
                resource: resource,
                displayTitle: resource.title + ' (' + attachment.settings.title + ')',
                isUnread: funcs.isUnread(resource, [attachment])
            });
        });

        if(otherAttachments.length > 0) {
            unreadInstances.push({
                attachments: otherAttachments,
                resource: resource,
                displayTitle: resource.title,
                isUnread: funcs.isUnread(resource, otherAttachments)
            });
        }

        return unreadInstances;
    },
    getHighlightsForBook: function(handle, bookId) {
        return _.filter(handle.$store.state.highlights, function(hl) {
            return hl.book === bookId;
        });
    },
    getHighlightsForBookPage: function(handle, bookId, section) {
        return _.find(handle.$store.state.highlights, function(hl) {
            return hl.book === bookId && hl.section === section;
        });
    },
    addHighlight: function(handle, hl) {
        handle.$store.state.highlights.push(hl);
    },
    addItemToSync: function(handle, obj) {
        handle.$store.commit("syncItem", obj);
    },
    goToStore: function(handle) {
        return handle.$store.state.deviceFeatures.storeUrl;
    },
    setUserPreferences: function(handle, key, value) {
        var userPreferences = handle.$store.state.userPreferences;

        if (!userPreferences) {
            userPreferences = {};
        }

        userPreferences[key] = value;
    },
    getUserPreferences: function(handle, key) {
        return handle.$store.state.userPreferences[key];
    },
    setLoginTime: function(handle) {
        var cDate = Date.now();
        handle.$store.state.loginTime = cDate;
        handle.$store.state.cookieExpireTime = cDate + 3600000; //1 hour
        // handle.$store.state.cookieExpireTime = cDate + 60000; //1 minute
    },
    getLoginTime: function(handle) {
        return handle.$store.state.loginTime;
    },
    getCookieExpireTime: function(handle) {
        return handle.$store.state.cookieExpireTime;
    },
    updateSince: function (handle) {
        handle.$store.state.since = Math.floor(Date.now() / 1000) - 120;
    },
    getSince: function(handle) {
        return handle.$store.state.since;
    },
    getCheckActive: function (handle) {
        return handle.$store.state.checkActive;
    },
    setCheckActive: function (handle, state) {
        handle.$store.state.checkActive = state;
    },
    getActive: function (handle) {
        return handle.$store.state.active;
    },
    setActive: function(handle, state) {
        handle.$store.state.active = state;
    },
    getExpireTimeDifference: function(handle, rTime) {
        var timeDifference = rTime - handle.$store.state.loginTime;
        var timeLeft = 2700000 - timeDifference; // 45minutes - (refresh time - current time) = minutes left to next popup
        // var timeLeft = 45000 - timeDifference; // 45seconds - (refresh time - current time) = seconds left to next popup
        return timeLeft;
    },
    checkActive: function(handle) {
        if (funcs.getCheckActive(handle)) {
            funcs.setActive(handle, true);
        }
    },
    setAnalytics: function(handle, onOff) {
        handle.$store.state.analytics = onOff;
    },
    setGroups: function (handle, groups) {
        handle.$store.state.groups = groups;
    },
    setPdfMemory(handle, memoryToStore, bookId, perPage = false, pageNr = null) {
        // first check if book in pdfMemory
        if (handle.$store.state.pdfMemory[bookId] == null) { // if pdfMemory is empty, create book entry
            handle.$store.state.pdfMemory[bookId] = {}
        }

        // all annotations were deleted on the page, remove completely from memory
        if (memoryToStore == null || memoryToStore.length == 0) {
            if (perPage == false) {
                handle.$store.state.pdfMemory[bookId] = null
            } else {
                // first find the page in memory
                let memoryToDeleteIndex = 0
                for (let [index, memory] of handle.$store.state.pdfMemory[bookId].memory.entries()) {
                    if (memory && memory.pageData != null && memory.pageData.pageNr == pageNr) {
                        // found page, update
                        memoryToDeleteIndex = index
                    }
                }

                handle.$store.state.pdfMemory[bookId].memory.splice(memoryToDeleteIndex, 1)

            }
            return
        }

        // book is now in memory
        // add bulk memory to bookId
        if (perPage == false) {
            handle.$store.state.pdfMemory[bookId].memory = memoryToStore
        } else {
            // if memory is empty, just add page
            if (handle.$store.state.pdfMemory[bookId].memory == null) {
                handle.$store.state.pdfMemory[bookId].memory = memoryToStore
            } else {
                // find page in memory
                let foundInMemoryIndex = null
                for (let [index, memory] of handle.$store.state.pdfMemory[bookId].memory.entries()) {
                    if (memory && memory.pageData != null && memory.pageData.pageNr == pageNr) {
                        // found page, update
                        foundInMemoryIndex = index
                    }
                }
                if (foundInMemoryIndex == null) {
                    // add to memory
                    handle.$store.state.pdfMemory[bookId].memory.push(memoryToStore[0])
                } else {
                    handle.$store.state.pdfMemory[bookId].memory[foundInMemoryIndex] = memoryToStore[0]
                }
            }
        }
    },
    getPdfMemory(handle, bookId, page = null) {
        // check if book in memory
        if (handle.$store.state.pdfMemory[bookId] == null) {
            return null
        }

        // if page is data is requested, return page, otherwise just return memory
        if (page == null) {
            return handle.$store.state.pdfMemory[bookId].memory
        }

        for (var memory of handle.$store.state.pdfMemory[bookId].memory) {
            if (memory && memory.pageData && memory.pageData.pageNr == page) {
                return memory
            }
        }

        return null
    },
    clearPdfMemory(handle, bookId) {
        handle.$store.state.pdfMemory[bookId] = {}
    },
    getAnalytics: function(handle) {
        return handle.$store.state.analytics;
    },
    updateLastAccessPage: function (handle, bookId, lastAccessedPage) {
        if (handle.$store.state.bookListLastAccessPage[bookId]) { // update
            handle.$store.state.bookListLastAccessPage[bookId].lastAccessedPage = lastAccessedPage
        } else { // create then add
            handle.$store.state.bookListLastAccessPage[bookId] = { "lastAccessedPage": lastAccessedPage}
        }
    },
    getLastAccessPage: function(handle, bookId) {
        if (handle.$store.state.bookListLastAccessPage[bookId])
            return handle.$store.state.bookListLastAccessPage[bookId].lastAccessedPage
        return null
    }
}

export default funcs;